import { MenuItem } from '@/types/menu';
import { OrdersIcon, RolesIcon, StoresIcon, DepartmentsIcon } from './icon';

export const sideBarItem: MenuItem[] = [
  {
    label: 'Stores',
    route: '/stores',
    icon: StoresIcon,
  },
  {
    label: 'Orders',
    route: '/orders',
    icon: OrdersIcon,
  },
  {
    label: 'Roles',
    route: '/roles',
    icon: RolesIcon,
  },
  {
    label: 'Departments',
    route: '/departments',
    icon: DepartmentsIcon,
  }
];
